import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'freight-icon',
  templateUrl: './freight-icon.component.html',
  styleUrls: ['./freight-icon.component.scss'],
  standalone: true,
})
export class FreightIconComponent implements OnInit {
  @Input() color: string | undefined;
  @Input() width: string = '14';
  @Input() height: string = '15';
  constructor() {}

  ngOnInit() {}
}
